import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegisterModel } from '../../../model/register-model';
import { AuthService } from '../../../services/auth.service';
import { SharedModule } from '../../../shared/shared-module.ts.module';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule, SharedModule],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss'
})
export class RegisterComponent {
  form: FormGroup;
  clientId: string | null = null;

  constructor(private authService: AuthService, private fb: FormBuilder, private router: Router, private spinner: NgxSpinnerService) {
    this.clientId = this.authService.getClienteIdLocal();

    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    });
  }

  create() {
    this.spinner.show();
    var clientId = this.authService.verificaClientId(this.clientId ?? '');
    const model = this.form.value as RegisterModel;
    model.clientId = clientId;

    this.authService.create(model).subscribe({
      next: (response) => {
        this.router.navigate(['/login']);
        this.spinner.hide();
      },
      error: (error) => {
        alert("Erro ao cadastrar usuário");
        this.spinner.hide();
        console.error(error);
      },
    });
  }
}
